import customAxios from "./axiosConfig";

const ForeignTaxReportService = {
    get: function (id, params) {
        var api_url = window.Urls['foreignvatreport_detail'](id);
        return customAxios.get(api_url, { params: params });
    },
    list: function (params) {
        var api_url = window.Urls['foreignvatreport_list']();
        return customAxios.get(api_url, { params: params });
    },
    recalculate: function (id, data) {
        var api_url = window.Urls['foreignvatreport_recalculate'](id);
        return customAxios.get(api_url, data);
    },
    create: function (data) {
        var api_url = window.Urls['foreignvatreport_list']();
        return customAxios.post(api_url, data);
    },
};

export default ForeignTaxReportService;